(function () {
  const STORAGE_KEY = 'minutedrone-tax-mode';
  // t12 : taux de TVA fourni par le snippet (data-vat-rate), 20 % par defaut.
  function vatDivisor(wrapper) {
    const rate = Number(wrapper && wrapper.dataset.vatRate);
    return 1 + (rate > 0 ? rate : 20) / 100;
  }

  function getSavedMode() {
    const saved = window.localStorage.getItem(STORAGE_KEY);
    return saved === 'ht' ? 'ht' : 'ttc';
  }

  function setSavedMode(mode) {
    window.localStorage.setItem(STORAGE_KEY, mode);
  }

  function formatMoney(cents) {
    const amount = (Number(cents) || 0) / 100;
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR'
    }).format(amount);
  }

  function applyMode(wrapper, mode) {
    const priceValue = wrapper.querySelector('[data-tax-price-value]');
    const compareWrap = wrapper.querySelector('[data-tax-compare-wrap]');
    const compareValue = wrapper.querySelector('[data-tax-compare-value]');
    const compareLabel = wrapper.querySelector('[data-tax-compare-label]');
    const subtext = wrapper.querySelector('[data-tax-subtext]');
    const buttons = wrapper.querySelectorAll('.md-tax-toggle__btn');

    const price = mode === 'ht' ? wrapper.dataset.priceHt : wrapper.dataset.priceTtc;
    const compare = mode === 'ht' ? wrapper.dataset.compareHt : wrapper.dataset.compareTtc;

    if (priceValue) {
      priceValue.textContent = formatMoney(price);
    }

    if (compareWrap && compareValue && compareLabel) {
      if (Number(compare) > 0) {
        compareWrap.hidden = false;
        compareValue.textContent = formatMoney(compare);
        compareLabel.textContent = mode.toUpperCase();
      } else {
        compareWrap.hidden = true;
        compareValue.textContent = '';
        compareLabel.textContent = '';
      }
    }

    if (subtext) {
      subtext.textContent = mode === 'ht' ? 'Hors Taxes.' : 'Taxes incluses.';
    }

    buttons.forEach((button) => {
      const isActive = button.dataset.taxMode === mode;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function initWrapper(wrapper) {
    if (!wrapper || wrapper.dataset.taxReady === 'true') return;

    wrapper.dataset.taxReady = 'true';

    const initialMode = getSavedMode();
    applyMode(wrapper, initialMode);

    wrapper.querySelectorAll('.md-tax-toggle__btn').forEach((button) => {
      button.addEventListener('click', function () {
        const mode = button.dataset.taxMode === 'ht' ? 'ht' : 'ttc';
        setSavedMode(mode);

        document.querySelectorAll('[data-tax-price]').forEach((el) => {
          applyMode(el, mode);
        });
      });
    });
  }

  function updateWrapperFromVariant(wrapper, variant) {
    if (!wrapper || !variant) return;

    const priceTtc = Number(variant.price || 0);
    const compareTtc = Number(variant.compare_at_price || 0);

    wrapper.dataset.variantId = String(variant.id || '');
    wrapper.dataset.priceTtc = String(priceTtc);
    wrapper.dataset.priceHt = String(Math.round(priceTtc / vatDivisor(wrapper)));
    wrapper.dataset.compareTtc = String(compareTtc);
    wrapper.dataset.compareHt = String(Math.round(compareTtc / vatDivisor(wrapper)));

    applyMode(wrapper, getSavedMode());
  }

  function initAll() {
    document.querySelectorAll('[data-tax-price]').forEach(initWrapper);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);

  document.addEventListener('variant:change', function (event) {
    const variant = event.detail && event.detail.variant ? event.detail.variant : null;
    if (!variant) return;

    const sectionRoot =
      (event.target && event.target.closest && event.target.closest('product-info')) ||
      (event.target && event.target.closest && event.target.closest('.product')) ||
      document;

    const wrapper = sectionRoot.querySelector('[data-tax-price]');
    if (!wrapper) return;

    updateWrapperFromVariant(wrapper, variant);
  });
})();